'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';

var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 4px;\n    display: block;\n"], ["\n    margin-bottom: 4px;\n    display: block;\n"])));
var templateObject_1;

export { Label };
//# sourceMappingURL=Select.css.js.map
